import { get } from "storefront/GrailedAPI/request";
import { Id } from "storefront/lib/Id";
import { GrailedAPIPhoto } from "storefront/Photo";

const SUGGESTED_REPOST = "SUGGESTED_REPOST" as const;

type SellerNotificationType = typeof SUGGESTED_REPOST;

type SuggestedRepostNotification = {
  listingId: Id;
  photo: GrailedAPIPhoto;
  type: SellerNotificationType;
  suggestedPrice: number;
};

type SellerNotification = SuggestedRepostNotification;

type SellerNotificationData = {
  sellerNotifications: Array<SellerNotification>;
  anyUnread: boolean;
};

type Response = {
  data: SellerNotificationData;
};

const getSellerNotifications = async (
  userId: Id,
): Promise<SellerNotificationData> => {
  const res = await get<Response>(`/api/users/${userId}/seller_notifications`);
  return res.data;
};

export default getSellerNotifications;
